var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","fullscreen":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('plot-list',{attrs:{"item-definition":_vm.itemDefinition,"fullscreen-mode":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }